import {
  createStartAction,
  createSuccessAction,
} from 'app/api/redux-util/async-helpers';
import {
  CREATE_PAGE_VIEWER,
  SET_DPS,
} from 'app/api/redux-jigsaw/jigsaw-methods';
import { withDestroyViewerReset } from 'app/api/reset-reducer-helpers';

function dpsReducer(state = false, action) {
  if (action.type === createStartAction(SET_DPS).type) {
    return action.data[0];
  } else if (action.type === createStartAction(CREATE_PAGE_VIEWER).type) {
    return !!action.data[0].dpsOn;
  } else if (action.type === createSuccessAction(CREATE_PAGE_VIEWER).type) {
    if (!action.data.dpsAvailable) {
      return false;
    }
  }
  return state;
}

export default withDestroyViewerReset(dpsReducer);



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/dps/reducer.js